import { GENERATE_IA_CONTENT_PAYLOAD } from '@app/_models/entity-ia-content/entity-ia-content.model';

export class GenerateIaContent {
    public static readonly type = '[EntityIaContent] GenerateIaContent';
    constructor(public payload: GENERATE_IA_CONTENT_PAYLOAD) {}
}

export class ClearIaContent {
    public static readonly type = '[EntityIaContent] ClearIaContent';
    constructor() {}
}
